import { DatePicker, Modal, Radio } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';
import dayjs from 'dayjs';

const RuleVersionModal = ({
  state,
  saveLoading,
  ruleDate,
  onOk,
}: {
  state: any;
  saveLoading: boolean;
  ruleDate: any;
  onOk: () => void;
}) => {
  const disabledDatee: RangePickerProps['disabledDate'] = (current) => {
    const startDate = dayjs(ruleDate?.[0]);
    const endDate = dayjs(ruleDate?.[1]);
    return current && (current.isBefore(startDate) || current.isAfter(endDate));
  };

  return (
    <Modal
      cancelText="Cancel"
      title="Rule Effective From"
      open={state.newVersionModal}
      okButtonProps={{
        disabled: state.selectedDateOption === 'next' && !state.selectedDate,
        loading: saveLoading,
      }}
      onOk={onOk}
      onCancel={() => {
        state.setNewVersionModal(false);
        state.setSelectedDateOption('current');
        state.setSelectedDate(null);
      }}
      maskClosable={false}
    >
      <Radio.Group
        onChange={(e) => state.setSelectedDateOption(e.target.value)}
        value={state.selectedDateOption}
      >
        <Radio value="current">Current</Radio>
        <Radio value="next">Next</Radio>
      </Radio.Group>
      {state.selectedDateOption === 'next' ? (
        <DatePicker
          disabledDate={disabledDatee}
          onChange={(date, dateString) => {
            state.setSelectedDate(dateString);
            state.setValidationMsg(false);
          }}
          showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }}
        />
      ) : null}
      {state.validationMsg ? (
        <p className="text-sm mb-0 m-1 text-[#ea4748]">{`Your Previous version date is ${state?.currentValues?.rule_start_date}. Please select a date/time with minimum of 2 seconds difference`}</p>
      ) : null}
    </Modal>
  );
};

export default RuleVersionModal;
